import React from 'react';
import style from './TranslateSwitchButton.module.scss'
import {getTranslation} from "@/utils/translation";

function TranslateSwitchButton(props) {
	const {
		currentContact,
		translationsEnabled,
		translationInfo,
		setTranslationInfo
    } = props;

	const translateView = translationInfo?.translateView;
	const translationNeeded = translationInfo?.isTranslationNeeded;

	const handleClick = () => {
		setTranslationInfo(prevState => {
			let info = prevState[currentContact];
			info.translateView = !translateView;
			return {
				...prevState,
				[currentContact]: info
			};
		});
	}

	return translationsEnabled && translationNeeded ?
		<div className={style.div_button}>
			Translation enabled
			<button
				className={"btn " + (!translateView ? style.enabled:'')}
				onClick={handleClick}
			>
				<i className="fas fa-eye mr-1" />
				{
					translateView ? "Customer View" : "Return to Agent View"
				}
			</button>
		</div>
		:
		<></>;
}

export default TranslateSwitchButton;